import { Turbo } from '@hotwired/turbo-rails';

const { StreamActions } = Turbo;

// eslint-disable-next-line func-names
StreamActions.redirect_to = function () {
  const url = this.getAttribute('url') || '/';
  const turboAction = (this.getAttribute('turbo_action') || 'advance');
  const turbo = this.getAttribute('turbo') === 'true';

  if (turbo) {
    if (window.Turbo) {
      window.Turbo.visit(url, { action: turboAction });
    }
    if (window.Turbolinks) {
      window.Turbolinks.visit(url, { action: turboAction });
    }
    if (!window.Turbo && !window.Turbolinks) {
      window.location.href = url;
    }
  } else {
    window.location.href = url;
  }
};
